<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    children,
    variant = 'secondary',
    type = 'button',
    disabled = false,
    ariaLabel,
    onclick,
  }: {
    children: Snippet;
    variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
    type?: 'button' | 'submit';
    disabled?: boolean;
    ariaLabel?: string;
    onclick?: (event: MouseEvent) => void;
  } = $props();
</script>

<button class="button {variant}" {type} {disabled} aria-label={ariaLabel} {onclick}>
  {@render children()}
</button>
